/**
 * Набор хелперов для работы со спиннерами и прелоадерами
 */

/**
 * HTML для ngx-spinner
 */
export const getSpinnerHtml = () =>
    '<div class="h-full w-full flex items-center justify-center"><div class="app-root-loader"></div></div>';
